import { ModalRating } from './../../components/modal-rating/modal-rating.model';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { Observable } from 'rxjs';
import { environment } from '@env';
import { IRequisition, RequisitionViewModelFactory } from '@project/view-models';
import { map } from 'rxjs/operators';
import { TGuid } from '@core/helpers';

@Injectable({
  providedIn: 'root',
})
export class ChatApiProviderService {
  constructor(private apiService: ApiService) {}

  getRequisitionByChatId(chatId: TGuid): Observable<IRequisition> {
    return this.apiService
      .get(`${environment.environmentVariables.apiCoreUrl}/Chats/${chatId}/requisitions`)
      .pipe(map((requisition) => RequisitionViewModelFactory.createGetViewModel(requisition)));
  }

  sendRating(modalRating: ModalRating): Observable<void> {
    return this.apiService.post(`${environment.environmentVariables.apiCoreUrl}/Chats/video/rating`, modalRating);
  }
}
